import React, { useEffect, useState } from 'react';

import cn from '@/utils/cn';

interface Props {
  img: string;
  name: string;
  variant?: 'normal' | 'chat' | 'clean';
  size?: 'small' | 'normal';
}

const Avatar: React.FC<Props> = ({
  img,
  name,
  variant = 'normal',
  size = 'normal',
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [img]);

  return (
    <div className="relative min-w-max max-w-max">
      <img
        src={hasError ? '/hf_logo.jpg' : img}
        alt={name}
        className={cn(
          'aspect-square size-[50px] shrink-0 rounded-full border border-gray-500 bg-gray-100 p-0.5',
          variant === 'chat' && 'size-[54px] bg-gray-100 lg:size-[60px]',
          size === 'small' && 'size-[36px] lg:size-[36px]'
        )}
        onError={() => {
          setHasError(true);
        }}
      />
      <div
        className={cn(
          'absolute bottom-[2px] right-[2px] size-[14px] rounded-full border-2 border-gray-100 bg-green-500 lg:bottom-[1px] lg:right-[1px]',
          variant === 'chat' && 'lg:bottom-[3px] lg:right-[3px]',
          variant === 'clean' && 'hidden'
        )}
      />
    </div>
  );
};

export default Avatar;
